// extracted by mini-css-extract-plugin
module.exports = {"rankingContainer__tabPanel":"rankingContainer__tabPanel","rankingContainer__singlePanelWrapper":"rankingContainer__singlePanelWrapper"};